module.exports = __webpack_public_path__ + "img/arrow-black.56eba05b.svg";